import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'unstated';
import { Redirect, Route } from 'react-router-dom';

import { IonApp, IonRouterOutlet, IonPage } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';

import * as serviceWorker from 'src/serviceWorker';
import { privateRoutes, publicRoutes } from 'src/routes';
import ErrorBoundry from 'src/components/ErrorBoundry';
import SideMenu from 'src/components/SideMenu';

import '@ionic/react/css/core.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';
import './index.scss';

class App extends React.Component {
  render() {
    return (
      <ErrorBoundry>
        <IonApp>
          <Provider>
            <IonReactRouter basename="/">
              <SideMenu />
              <IonPage id="mainContent">
                <IonRouterOutlet>
                  {publicRoutes.map((route, index) => (
                    <Route
                      key={route.key || index}
                      exact
                      path={route.path}
                      component={route.component}
                    />
                  ))}
                  {privateRoutes.map((route, index) => (
                    <Route
                      key={route.key || index}
                      exact
                      path={route.path}
                      component={route.component}
                    />
                  ))}

                  {/* IonRouterOutlet is not like a Switch and cannot handle
                    wildcard redirects. It also gets wierd about redirects
                    in general. Until there is an update to how the router
                    works, we can't really handle 404 redirects */}
                  <Route
                    exact
                    path="/"
                    render={() => <Redirect to="/jobs" />}
                  />
                </IonRouterOutlet>
              </IonPage>
            </IonReactRouter>
          </Provider>
        </IonApp>
      </ErrorBoundry>
    );
  }
}

ReactDOM.render(<App />, document.getElementById('root'));
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
